// extracted by mini-css-extract-plugin
export default {"root":"ScreenLayout_root__pQBL9"};